import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {AppService} from "@irb/app.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {IAlternateSecurities, IAlternativeSecurity, IModelSecurityEquivalent} from "@irb/irb-editors/irb-editors.model";
import {IrbEditorsEvents} from "@irb/irb-editors/irb-editors.events";
import {IrbAppEvents} from "@irb/app.events";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {IEvent} from "@irb-common/events";
import {Subscription} from "rxjs";
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
    selector: 'irb-com-es-security-alternatives',
    templateUrl: './com-es-security-alternatives.component.html',
    styleUrls: ['./com-es-security-alternatives.component.scss']
})
export class ComEsSecurityAlternativesComponent implements OnInit, OnDestroy {
    @ViewChild("alternateSecurityDropdown") alternateSecurityDropdown: any;
    _securityAlternativesData: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] };
    private eventSubscription: Subscription;
    alternateSecuritySelectedInitial: any;
    inverseAccountTypeInitial: any;
    selectedInverseAccountType: string;
    selectedAltSecurity: IDropdownItem;
    alternativeSecurities: Array<IDropdownItem> = [];
    alternateSecurityPlaceHolder = "-Search-";
    private _isDataLoaded: boolean = false;
    tooltipDescMessage = "";
    allInverseAlternateSecurities: Array<IAlternativeSecurity>=[];
    addNewSecurityItem: any = {
        button: 'Add new security',
        type: 'security',
        fromComp: 'ComEsSecurityAlternativesComponent'
    };
    @Output()
    securityEquivalentsAlternativeChanged: EventEmitter<{ alternativeSecurity: IAlternativeSecurity, inverseAccountType: string }>
        = new EventEmitter<{ alternativeSecurity: IAlternativeSecurity, inverseAccountType: string }>();

    @Input()
    set securityAlternativesData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
        this._isDataLoaded = false;
        this._securityAlternativesData = value;
        this.alternateSecuritySelectedInitial = null;
        this.inverseAccountTypeInitial = null;
        this.selectedInverseAccountType = null;
        this.selectedAltSecurity = null;
        this.alternateSecurityPlaceHolder = "";
        this.loadData();
    }

    constructor(private irbEditorsService: IrbEditorsService,
                private as: AppService,
                private utilService: UtilityService,
                private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });
        this.irbEditorsService.getInvrsSub().subscribe(
            (securityAlternatives: IAlternateSecurities) => {
                if (securityAlternatives.items && securityAlternatives.items.length > 0) {
                    this.allInverseAlternateSecurities.push(...securityAlternatives.items);
                    securityAlternatives.items.forEach((item: any) => {
                        this.alternativeSecurities.push({
                            name: item.securitySymbol,
                            value: item.securityId
                        } as IDropdownItem);
                    });

                    this.utilService.sortByKey(this.alternativeSecurities, "name", "asc");
                    
                    this.alternativeSecurities.unshift({
                        value: 0,
                        name: "None"
                    } as IDropdownItem);

                    this.setAlternateSecurity();
                }
            });
    }


    private processEvent(event: IEvent) {

        switch (event.type) {
            case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
                if (event.data && event.data.editSecurity === true) {
                    this.addNewlyCreatedSecurity(event);
                }if (event.data.type === 'security' && event.data.fromComp === 'ComEsSecurityAlternativesComponent') {
                    this.resetSecuritySearch(event.data)
                }
                break;
        }
    }
    private loadData() {
        if (this._securityAlternativesData) {
            this.setAlternateSecurity();
            this._isDataLoaded = true;
        }
    }

    private setAlternateSecurity() {

        if (this._securityAlternativesData && this._securityAlternativesData.multipleSecurity) {
            let taxableAlternativeSymbol = this.getInitialValue("taxableAlternativeSymbol", this._securityAlternativesData.securityData);
            let qualifiedAlternativeSymbol = this.getInitialValue("qualifiedAlternativeSymbol", this._securityAlternativesData.securityData);
            this.inverseAccountTypeInitial = this.getInitialValue('invrsAccountType', this._securityAlternativesData.securityData);
            this.alternateSecuritySelectedInitial = (taxableAlternativeSymbol ? taxableAlternativeSymbol : qualifiedAlternativeSymbol);
            this.selectedAltSecurity = this.alternateSecuritySelectedInitial;
            if (this.inverseAccountTypeInitial === 'Various') {
                this.selectedInverseAccountType = null;
            } else {
                this.selectedInverseAccountType = this.inverseAccountTypeInitial;
            }
        } else {
            let taxableAlternativeSymbol = this._securityAlternativesData.securityData[0].taxableAlternativeSymbol;
            let qualifiedAlternativeSymbol = this._securityAlternativesData.securityData[0].qualifiedAlternativeSymbol;
            if (taxableAlternativeSymbol || qualifiedAlternativeSymbol) {
                this.alternateSecuritySelectedInitial = taxableAlternativeSymbol ? taxableAlternativeSymbol : qualifiedAlternativeSymbol;
            } else {
                this.alternateSecuritySelectedInitial = 0;
            }
            if (this._securityAlternativesData.isModelSecurity) {
                this.inverseAccountTypeInitial = this._securityAlternativesData.securityData[0].inverseAccType;
            } else {
                this.inverseAccountTypeInitial = this._securityAlternativesData.securityData[0].invrsAccountType;
            }
            this.selectedInverseAccountType = this.inverseAccountTypeInitial;
        }
        if (this.alternateSecuritySelectedInitial === "Various") {
            this.alternateSecurityPlaceHolder = "Various";
        } else {
            this.alternateSecurityPlaceHolder = "-Search-";
        }
        if (this.alternativeSecurities && this.alternativeSecurities.length > 0) {
            const altSelected = this.alternativeSecurities.find(x => x.value === this.alternateSecuritySelectedInitial);
            this.selectedAltSecurity = altSelected;
            if (this.alternateSecurityDropdown && this.alternateSecurityDropdown.setValue)
                this.alternateSecurityDropdown.setValue(this.selectedAltSecurity);
        }
    }

    private getInitialValue(name: string, items: any[]) {
        let inputVal = items[0][name];
        for (let i = 0; i < items.length; i++) {
            let thisVal = items[i][name];
            if (inputVal != thisVal) {
                inputVal = "Various";
            }
        }
        return inputVal;
    }

    onAlternativeSecurityChanged(event: IDropdownItem) {
        this.selectedAltSecurity = event;
        this.selectedInverseAccountType = null;
        if (this.selectedAltSecurity.value === 0 || this.selectedAltSecurity.value === null) {
            this.tooltipDescMessage = "";
            let altSecurity: IAlternativeSecurity = {
                securityDesc: "None",
                securityId: 0,
                securitySymbol: "None"
            };
            this.securityEquivalentsAlternativeChanged.emit({
                alternativeSecurity: altSecurity,
                inverseAccountType: this.selectedInverseAccountType
            });
        } else {
            this.tooltipDescMessage = "Selection required";
            let altSecurity: IAlternativeSecurity;
            altSecurity =this.allInverseAlternateSecurities.find((x:IAlternativeSecurity) => x.securityId === this.selectedAltSecurity.value);

            this.securityEquivalentsAlternativeChanged.emit({
                alternativeSecurity: altSecurity,
                inverseAccountType: this.selectedInverseAccountType
           });
        }
        this.cdr.detectChanges();
    }

    onInverseAccountTypeChange() {
        this.tooltipDescMessage = "";
        let altSecurity: IAlternativeSecurity;
        altSecurity =this.allInverseAlternateSecurities.find((x:IAlternativeSecurity) => x.securityId === this.selectedAltSecurity.value);
        this.securityEquivalentsAlternativeChanged.emit({
            alternativeSecurity: altSecurity,
            inverseAccountType: this.selectedInverseAccountType
        });
    }

    onCreateNewSecurity() {
        const dataParam: any = {
            editSecurity: true,
            editSecurityTaxQualAlternateSymbol: true
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }

    resetSecuritySearch(event: any) {
        const dataParam: any = event;
        if (dataParam && dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
            if (dataParam.newItemsForDD && dataParam.newItemsForDD.length !== 0) {
                this.selectedAltSecurity = dataParam.newItemsForDD[0];
            }
        }
    }

    addNewlyCreatedSecurity(event: IEvent) {
        const newData = event.data;
        // console.log('New Dat Received', newData);
        const alternativeSecurities: Array<IDropdownItem> = [];

        if (newData.securities && newData.securities.responseData && newData.securities.responseData.length !== 0) {
            let newSecurityItem: any;
            newData.securities.responseData.forEach((item: any) => {
                newSecurityItem = this.buildAlternativeSecurityItem(item);
                this.allInverseAlternateSecurities.push(newSecurityItem);
                let newSecurityDropdownItem:IDropdownItem = {name:newSecurityItem.securitySymbol, value:newSecurityItem.securityId};
                alternativeSecurities.push(newSecurityDropdownItem);
            });

            if(alternativeSecurities && alternativeSecurities.length > 0) {
                let newConsolidatedAlternatives: Array<IDropdownItem> = [];

                if (this.alternativeSecurities?.length > 0) {
                    newConsolidatedAlternatives.push(...this.alternativeSecurities);
                }

                newConsolidatedAlternatives.push(...alternativeSecurities);
                const noneItemIndex = newConsolidatedAlternatives.findIndex(x => x.value === 0);

                if (noneItemIndex >= 0) {
                    newConsolidatedAlternatives.splice(noneItemIndex, 1);
                }

                newConsolidatedAlternatives = this.utilService.sortByKey(newConsolidatedAlternatives, "name", "asc");

                newConsolidatedAlternatives.unshift({
                    value: 0,
                    name: "None"
                } as IDropdownItem);

                this.alternativeSecurities = newConsolidatedAlternatives;
                this.cdr.detectChanges();
            }
        }
    }

    private buildAlternativeSecurityItem(response: any) {
        let newAlternateSecurity: IAlternativeSecurity = {
            securityDesc: response.securityDescription,
            securityId: response.securityId,
            securitySymbol: response.securitySymbol,
        };
        return newAlternateSecurity;
    }

    ngOnDestroy(): void {
        if (this.eventSubscription) {
            this.eventSubscription.unsubscribe();
        }
    }

    getItemsForAlternateSecurityDropdown(searchString: string) {
        this.alternateSecurityDropdown.set(DropdownFilterComponent.getFilteredList(searchString,this.alternativeSecurities));
    }

    openNewItemSecurityFlow(dataParam: any) {
        dataParam = Object.assign({}, this.addNewSecurityItem, dataParam);
        dataParam.editSecurity = true;
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }
}
